import React from "react";
import "../Style/Dmrec.css";

import achieve from "../assets/achieve.png";
import compete from "../assets/compete.png";
import expand from "../assets/expand.png";
import convert from "../assets/convert.png";
import dedicated from "../assets/dedicated.png";
import trapLeft from "../assets/left-corner.png";
import trapRight from "../assets/right-corner.png";

function Dmrec() {
  return (
    <section className="dmrec">
      <div className="dmrec-container">
        <img src={trapLeft} alt="" className="trap-left" />
        <img src={trapRight} alt="" className="trap-right" />

        <h2 className="dmrec-title">
          Why Choose MPeoples for Digital Marketing Services?
        </h2>
        <p className="dmrec-subtitle">Reach. Engage. Convert.</p>

        {/* TOP ROW */}
        <div className="dmrec-row top">
          <div className="dmrec-card">
            <img src={achieve} alt="" />
            <h3>Drive Higher ROI with Performance Marketing</h3>
            <p>
              Our performance-driven digital marketing strategies focus on
              maximizing return on investment (ROI). Through data analysis,
              campaign optimization, and targeted advertising, we help
              businesses generate qualified leads, increase conversions, and
              achieve sustainable business growth.
            </p>
          </div>

          <div className="dmrec-card">
            <img src={compete} alt="" />
            <h3>Outperform Your Competitors Online</h3>
            <p>
              Stay ahead of the competition with customized digital marketing
              solutions designed to strengthen your online presence. From SEO to
              paid advertising and social media marketing, we position your
              brand where your customers are searching.
            </p>
          </div>

          <div className="dmrec-card">
            <img src={expand} alt="" />
            <h3>Increase Brand Visibility Across Digital Channels</h3>
            <p>
              Expand your brand reach through integrated digital marketing
              campaigns across search engines, social media platforms, content
              marketing, and local SEO strategies that attract the right
              audience.
            </p>
          </div>
        </div>

        {/* DIVIDER */}
        <div className="dmrec-divider"></div>

        {/* BOTTOM ROW */}
        <div className="dmrec-row bottom">
          <div className="dmrec-card">
            <img src={convert} alt="" />
            <h3>Turn Website Visitors into Loyal Customers</h3>
            <p>
              We create optimized customer journeys that convert visitors into
              paying customers through engaging content, conversion-focused
              landing pages, and personalized marketing strategies.
            </p>
          </div>

          <div className="dmrec-card">
            <img src={dedicated} alt="" />
            <h3>Dedicated Digital Marketing Experts</h3>
            <p>
              Our experienced digital marketing specialists continuously
              monitor, analyze, and optimize campaigns to deliver measurable
              results, higher engagement, and long-term business success.
            </p>
          </div>
        </div>

        {/* CTA */}
        {/* <div className="dmrec-cta">
          <button className="dmrec-btn">
            Let’s Build Together <span>↗</span>
          </button>

          <div className="dmrec-free">
            Free consultation
            <div className="dmrec-circle">↗</div>
          </div> */}
        {/* </div> */}
      </div>
    </section>
  );
}

export default Dmrec;
